import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  // Initialize the subject during declaration with a placeholder value (will be updated in constructor)
  private currentLangSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  currentLang$ = this.currentLangSubject.asObservable();

  constructor() {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    let defaultLang: string | null = 'se'; // Default language for routing

    // Check the hostname and set language, or remove it if needed
    if (environment.seDomains.includes(hostname) && pathname === '/') {
      defaultLang = '';  // Remove the language prefix 
    } else if (environment.dkDomains.includes(hostname)) {
      defaultLang = '';  // Remove the language prefix 
    } else if (environment.noDomains.includes(hostname)) {
      defaultLang = '';  // Remove the language prefix 
    } else if (environment.noAEGDomains.includes(hostname)) {
      defaultLang = '';  // Remove the language prefix 
    } else if (environment.dkAEGDomains.includes(hostname)) {
      defaultLang = '';  // Remove the language prefix 
    } else if (pathname.startsWith('/se')) {
      defaultLang = 'se';
    } else if (pathname.startsWith('/dk')) {
      defaultLang = 'dk';
    } else if (pathname.startsWith('/no')) {
      defaultLang = 'no';
    } else if (pathname.startsWith('/aeg-dk')) {
      defaultLang = 'aeg-dk';
    } else if (pathname.startsWith('/elx-dk')) {
      defaultLang = 'elx-dk';
    } else if (pathname.startsWith('/aeg-no')) {
      defaultLang = 'aeg-no';
    }

    // Set the correct or null language after determining the domain
    this.currentLangSubject.next(defaultLang);
  }

  // Method to set the current language (can still be used for manual language setting)
  setLanguage(lang: string | null) {
    this.currentLangSubject.next(lang);
  }
}
